import logo from './logo.svg';
import './App.css';
import Registration from './pages/Registration';

function App() {
  return (
    
      <Registration/>
    
  );
}

export default App;
